import React, { useState, useMemo, useEffect } from 'react';
import cx from 'classnames';
import '../../../ui/accordions/Accordion/index.js';
import '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import { GradientButton } from '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import { TabButtonV2 } from '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import '../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../ui/modals/Modal/Modal.js';
import '../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../common/GradientWrapper/index.js';
import { Icon } from '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import { Range } from '../Range/index.js';
import styles from './index.module.scss.js';

const RewardsSlider = ({
  className,
  style,
  monthRange,
  weekRange,
  onConfirm,
  forceMobileStyles,
  showConfirmButton,
  onTabChange,
  onTooltipClick = () => {
  },
  texts = {
    title: "Rewards Slider",
    description: "Adjust the scale to set your Weekly & Monthly rewards between Rakeback and Lossback.",
    confirmButton: "Confirm",
    weekly: "Weekly",
    monthly: "Monthly",
    rakeback: "Rakeback",
    lossback: "Lossback",
    lockedWeekTitle: "Feature locked",
    lockedMonthTitle: "Feature locked",
    lockedWeekSubtitle: "Earn more XP and reach level \u2018Silver 1\u2019 to unlock the Rewards Slider. Play games, place bets, or complete challenges to boost your progress!",
    lockedMonthSubtitle: "Earn more XP and reach level \u2018Gold 1\u2019 to unlock the Rewards Slider. Play games, place bets, or complete challenges to boost your progress!"
  },
  initActiveTab = 0,
  ...props
}) => {
  const [activeTab, setActiveTab] = useState(initActiveTab);
  const isShowLock = useMemo(
    () => activeTab === 0 && weekRange.isLocked || activeTab === 1 && monthRange.isLocked,
    [activeTab, weekRange, monthRange]
  );
  const currentLockTexts = useMemo(
    () => ({
      title: activeTab === 0 ? texts.lockedWeekTitle : texts.lockedMonthTitle,
      subtitle: activeTab === 0 ? texts.lockedWeekSubtitle : texts.lockedMonthSubtitle
    }),
    [activeTab, texts]
  );
  useEffect(() => {
    if (weekRange.isLocked) return;
    setActiveTab(initActiveTab);
  }, [initActiveTab, monthRange, weekRange]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, className, {
        [styles["mobile-styles"]]: forceMobileStyles,
        [styles["is-locked"]]: isShowLock
      }),
      style,
      ...props
    },
    /* @__PURE__ */ React.createElement("div", { className: cx(styles["box-inner"]) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.header) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.col) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.title) }, /* @__PURE__ */ React.createElement(Icon, { iconName: "Settings2" }), texts.title, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles["tooltip-button"]),
        onClick: onTooltipClick,
        tabIndex: 0,
        role: "button",
        "aria-label": "tooltip",
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            onTooltipClick();
          }
        }
      },
      /* @__PURE__ */ React.createElement(Icon, { iconName: "InfoFillV2" })
    )), /* @__PURE__ */ React.createElement("div", { className: cx(styles.subtitle) }, texts.description)), /* @__PURE__ */ React.createElement("div", { className: cx(styles.col) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.tabs) }, /* @__PURE__ */ React.createElement(
      TabButtonV2,
      {
        index: 0,
        active: activeTab === 0 && !weekRange.isLocked,
        onClick: (v) => {
          if (weekRange.isLocked) return;
          setActiveTab(v);
          onTabChange?.(v);
        },
        text: texts.weekly
      }
    ), /* @__PURE__ */ React.createElement(
      TabButtonV2,
      {
        index: 1,
        active: activeTab === 1 && !weekRange.isLocked,
        onClick: (v) => {
          if (weekRange.isLocked) return;
          setActiveTab(v);
          onTabChange?.(v);
        },
        text: texts.monthly
      }
    )))), /* @__PURE__ */ React.createElement("div", { className: cx(styles.body) }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles["tab-panel"], {
          [styles.active]: activeTab === 0
        })
      },
      /* @__PURE__ */ React.createElement(Range, { ...weekRange })
    ), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles["tab-panel"], {
          [styles.active]: activeTab === 1
        })
      },
      /* @__PURE__ */ React.createElement(Range, { ...monthRange })
    )), /* @__PURE__ */ React.createElement("div", { className: cx(styles.footer) }, /* @__PURE__ */ React.createElement("div", { className: cx(styles.col) }, /* @__PURE__ */ React.createElement(
      Range.RangeMarks,
      {
        data: [
          {
            label: texts.rakeback,
            type: "rakeback"
          },
          {
            label: texts.lossback,
            type: "lossback"
          }
        ]
      }
    )), /* @__PURE__ */ React.createElement("div", { className: cx(styles.col) }, showConfirmButton && /* @__PURE__ */ React.createElement(
      GradientButton,
      {
        kind: "fill",
        text: texts.confirmButton,
        size: "md-2",
        onClick: onConfirm
      }
    ))), isShowLock && /* @__PURE__ */ React.createElement("div", { className: styles.locked }, /* @__PURE__ */ React.createElement("div", { className: styles.locked__title }, /* @__PURE__ */ React.createElement(Icon, { iconName: "LockOrange" }), currentLockTexts.title), /* @__PURE__ */ React.createElement("div", { className: styles.locked__subtitle }, currentLockTexts.subtitle)))
  );
};
RewardsSlider.displayName = "RewardsSlider";

export { RewardsSlider };
//# sourceMappingURL=index.js.map
